
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                Gestion des tiers médicaux
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="tiers"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="tiers.length==0" loading-text="Chargement en cours...">

                                <template v-slot:item.zone="{item}">
                                    {{item.zone.nom}}
                                </template>
                                <template v-slot:item.departement_slug="{item}">
                                    {{item.departement_slug.name}}
                                </template>
                                <template v-slot:item.type_tier="{item}">
                                    {{item.type_tier.name}}
                                </template>

                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" style="z-index: 9999" max-width="900px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouveau  tier
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="nomRules" v-model="editedItem.name"
                                                                        label="Nom complet" placeholder="ex : NOM"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="phoneRules" v-model="editedItem.tel"
                                                                        label="Téléphone" placeholder="ex : +22969965844" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="latitudeRules" v-model="editedItem.latitude"
                                                                        label="Latitude" placeholder="ex : 1.5" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="longitudeRules" v-model="editedItem.longitude"
                                                                        label="Longitude" placeholder="ex : 1.2" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field
                                                                        clearable :rules="adressRules" v-model="editedItem.adress"
                                                                        label="Adresse" placeholder="ex : 01 BP COTONOU" ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="departementRules" @change="departementChanged"   v-model="editedItem.departement_slug" item-text="name" item-value="_id" :items="departements" label="Departement"   persistent-hint>

                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="quartierRules" @change="quartierChanged"   v-model="editedItem.zone" item-text="nom" item-value="_id" :items="quartiers" label="Quartier"   persistent-hint>

                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="assureurRules" @change="assureurChanged"   v-model="editedItem.assureur_id" item-text="name" item-value="_id" :items="assureurs" label="Assureurs"  multiple
                                                                >
                                                                    <template v-slot:selection="{ item, index }">
                                                                        <v-chip v-if="index === 0">
                                                                            <span>{{ item.name}}</span>
                                                                        </v-chip>
                                                                        <span
                                                                                v-if="index === 1"
                                                                                class="grey--text caption"
                                                                        >(+{{ editedItem.assureur_id.length - 1 }} others)</span>
                                                                    </template>

                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="typeRules" @change="typeChanged"   v-model="editedItem.type_tier" item-text="name" item-value="_id" :items="types" label="Type"   persistent-hint>

                                                                </v-select>
                                                            </v-col>

                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <v-dialog v-model="update" max-width="500px">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="nomRules" v-model="editedItem.name"
                                                                        label="Nom complet" placeholder="ex : NOM"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="phoneRules" v-model="editedItem.tel"
                                                                        label="Téléphone" placeholder="ex : +22969965844" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="latitudeRules" v-model="editedItem.latitude"
                                                                        label="Latitude" placeholder="ex : 1.5" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6">
                                                                <v-text-field
                                                                        clearable :rules="longitudeRules" v-model="editedItem.longitude"
                                                                        label="Longitude" placeholder="ex : 1.2" type="number"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field
                                                                        clearable :rules="adressRules" v-model="editedItem.adress"
                                                                        label="Adresse" placeholder="ex : 01 BP COTONOU" ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="departementRules" @change="departementChanged"   v-model="editedItem.departement_slug" item-text="name" item-value="_id" :items="departements" label="Departement"   persistent-hint>

                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="6" sm="6" md="6" >
                                                                <v-select :rules="quartierRules" @change="quartierChanged"   v-model="editedItem.zone" item-text="nom" item-value="_id" :items="quartiers" label="Quartier"   persistent-hint>

                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12" >
                                                                <v-select :rules="typeRules" @change="typeChanged"   v-model="editedItem.type_tier" item-text="name" item-value="_id" :items="types" label="Type"   persistent-hint>

                                                                </v-select>
                                                            </v-col>

                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="closed">Annuler</v-btn>
                                                    <v-btn color="blue darken-1"   text @click="updated">Sauvegarder</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                        <div class="d-flex ">
                            <v-menu
                                    key="text"
                                    rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">
                                    
                                          <v-icon v-bind="attrs"
                                            v-on="on" color='primary'>mdi-dots-vertical</v-icon>
                                    
                                </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_items"
                                            :key="index"
                                            link
                                            @click="editItemAction(item,index)">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                                    
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "Tier",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                update: '',
                quartierHasChanged:false,
                departementHasChanged:false,
                assureurHasChanged:false,
                typeHasChanged:false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                show1: false,
                headers: [
                    {
                        text: 'Nom ',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {text: 'Adresse', value: 'adress'},
                    {text: 'Téphone', value: 'tel'},
                    {text: 'Latitude', value: 'latitude'},
                    {text: 'Longitude', value: 'longitude'},
                    {text: 'Departement', value: 'departement_slug'},
                    {text: 'Quartier', value: 'zone'},
                    {text: 'Type', value: 'type_tier'},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                nomRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                phoneRules: [
                    v => !!v || 'Téléphone requis',
                ]
                ,
                latitudeRules: [
                    v => !!v || 'Latitude requis',
                ],
                longitudeRules: [
                    v => !!v || 'Longitude requis',
                ],
                quartierRules: [
                    v => !!v || 'Quartier requis',
                ],
                departementRules: [
                    v => !!v || 'Département requis',
                ],
                assureurRules: [
                    v => !!v || 'Assureur requis',
                ],
                typeRules: [
                    v => !!v || 'Type requis',
                ],
                adressRules: [
                    v => !!v || 'Adresse requise',
                ],
                actions_items: [
                    { title: "Assureurs" },
                    { title: "Modifier" },
                    { title: "Supprimer" }
                ],

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouveau tier" : "Mise à jour"
            }
            ,
            ...mapState('tiers/', ['tiers']),
            ...mapState('quartiers/', ['quartiers']),
            ...mapState('assureurs/', ['assureurs']),
            ...mapState('types/', ['types']),
            ...mapState('departements/', ['departements'])

        }
        ,
        mounted() {
            this.$store.dispatch('tiers/getTier').then(response => {
                window.console.log('tiers', response)
            });
            this.$store.dispatch('departements/getDepartement').then(response => {
                window.console.log('departements', response)
            });
            this.$store.dispatch('types/getType').then(response => {
                window.console.log('types', response)
            });
            this.$store.dispatch('assureurs/getAssureur').then(response => {
                window.console.log('assureurs', response)
            });
            this.$store.dispatch('quartiers/getQuartier').then(response => {
                window.console.log('quartiers', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
            update(val) {
                val || this.closed()
            }
        }
        ,
        methods: {
            initialize() {

            }
            ,
            editItemAction(item,index) {

               
                        switch (index){
                            case 0:
                                this.$router.push({ name: 'tiersassurance', params: { id: item._id } })
                                break;
                            case 1:
                                this.editItem(item);
                                break;
                            case 2:
                               this.deleteItem(item);
                                break;
                        }

                       

            },
            quartierChanged(){
                this.quartierHasChanged = true;
            },

            departementChanged(){
                this.departementHasChanged = true;
            },
            assureurChanged(){
                this.assureurHasChanged = true;
            },
            typeChanged(){
                this.typeHasChanged = true;
            },


            editItem(item) {
                this.editedIndex = this.tiers.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.update = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('tiers/deleteTier', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$refs.form.reset();
                this.$refs.form.reset();
                this.typeHasChanged = false;
                this.assureurHasChanged = false;
                this.quartierHasChanged = false;
                this.departementHasChanged = false;
                this.$store.dispatch('tiers/getTier').then(response => {
                    window.console.log('tiers', response)
                });


            },
            closed() {
                this.update = false;
                this.$refs.form.reset()
                this.typeHasChanged = false;
                this.assureurHasChanged = false;
                this.quartierHasChanged = false;
                this.departementHasChanged = false;
                this.$store.dispatch('tiers/getTier').then(response => {
                    window.console.log('tiers', response)
                });




            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("nom", this.editedItem.name);
                data.append("phone", this.editedItem.tel);
                data.append("latitude", this.editedItem.latitude);
                data.append("longitude", this.editedItem.longitude);
                data.append("adress", this.editedItem.adress);
                if ( this.typeHasChanged)
                    data.append("type_tier",this.editedItem.type_tier);

                if ( this.departementHasChanged)
                    data.append("departement_slug",this.editedItem.departement_slug);

                if ( this.quartierHasChanged)
                    data.append("zone",this.editedItem.zone);

                if ( this.assureurHasChanged)
                    data.append("assureur_id",JSON.stringify(this.editedItem.assureur_id));

                let mineroute = 'tiers/setTier';

                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();

                    }
                })
            },
            updated() {
                this.submitting = true;
                let data = new FormData();
                data.append("nom", this.editedItem.name);
                data.append("phone", this.editedItem.tel);
                data.append("latitude", this.editedItem.latitude);
                data.append("longitude", this.editedItem.longitude);
                data.append("adress", this.editedItem.adress);
                data.append("id",this.editedItem._id);
                if ( this.typeHasChanged){
                    data.append("type_tier",this.editedItem.type_tier);
                }

                if ( this.departementHasChanged){
                    data.append("departement_slug",this.editedItem.departement_slug);
                }

                if ( this.quartierHasChanged){
                    data.append("zone",this.editedItem.zone);
                }
                let mineroute = 'tiers/setTier';
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {

                        this.closed();

                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>